module.exports = __webpack_public_path__ + "static/media/call-auth-advantage-completing.3f759dbd.png";